import { AfterContentInit, Component, ElementRef, ViewChild } from '@angular/core';

@Component({
    selector: 'app-pdf-signature',
    templateUrl: './pdf-signature.component.html'
})

export class PdfSignatureComponent implements AfterContentInit {
    @ViewChild('iframe') iframe: ElementRef;

    iframeSrc = "https://survey.typeform.com/to/WkWrb35G";

    ngAfterContentInit(): void {
        setTimeout(() => {
            this.iframe.nativeElement.src = this.iframeSrc;
        }, 0);
    }
}
